import styled from 'styled-components';
import { ASubheaderTag } from './ASubheader.types';
import { baseVariables } from '../../styles';

const { spacers } = baseVariables;

export const Wrapper = styled(ASubheaderTag.h2)`
  margin-block-end: 0;
  padding-block-end: ${spacers?.spacers?.[1] ?? '0.25rem'};
`;
